import React from "react";

// react router
import { Link } from "react-router-dom";

import { FaLongArrowAltRight } from "react-icons/fa";
import {
    FurniturePlaceContainer,
    Container,
    Title,
    Span,
    LinkOuter,
    LinkSpan,
    Row,
    Image,
} from "../../styles/FurniturePlace";

// images
import mainImg from "assets/images/aplcetosnuggle/mainImg.jpg";

function FurniturePlace(props) {
    return (
        <FurniturePlaceContainer>
            <Container className="container-fluid">
                <Title>
                    <Span>FURNITURE</Span>a place to snuggle up
                    <LinkOuter>
                        <Link
                            to="/shop/furniture?id=12"
                            className="text-decoration-none"
                        >
                            <LinkSpan>
                                Our bestselling family sofa, Lounge, gets modern
                                comfort just right.
                                <FaLongArrowAltRight
                                    style={{ height: "14px", width: "auto" }}
                                />
                            </LinkSpan>
                        </Link>
                    </LinkOuter>
                </Title>
                <Row>
                    <LinkOuter className="text-center">
                        <Link
                            to="/shop/furniture?id=12"
                            className="text-decoration-none"
                        >
                            <Image src={mainImg} className="img-fluid" />
                        </Link>
                    </LinkOuter>
                </Row>
            </Container>
        </FurniturePlaceContainer>
    );
}

export default FurniturePlace;
